import * as React from 'react';

import { noop } from '@utils/noop';

import { IProductItemProps } from './model';
import { StyledProductTile } from './styled';
import { useProductItemProps } from './useGetProductItemProps';

export const ProductItem: React.FC<IProductItemProps> = React.memo(
  ({
    columns,
    innerRef,
    onProductAdded = noop,
    onProductAddFailed = noop,
    onClosingCartModal = noop,
    setProductWishlisted,
    sendGTM = false,
    useMasterUrl = false,
    showBuyButton = false,
    showWishlistButton = true,
    position = 0,
    inSectionOfType = '',
    appendComponent = null,
    showAddToCartModal = true,
    canSpaRedirect = true,
    ...rest
  }) => {
    const productProps = useProductItemProps({
      useMasterUrl,
      inSectionOfType,
      sendGTM,
      canSpaRedirect,
      setProductWishlisted,
      onProductAdded,
      onProductAddFailed,
      onClosingCartModal,
      showBuyButton,
      showWishlistButton,
      showAddToCartModal,
      position,
      appendComponent,
      ...rest,
    });

    if (!productProps) {
      return null;
    }

    return (
      <StyledProductTile
        data-testid="product-item"
        columns={columns}
        ref={innerRef}
        data-cypress="productItem-container"
        productProps={productProps}
      />
    );
  }
);

export default ProductItem;
